
import { Component, Vue } from 'vue-property-decorator';
import { Html5Qrcode, Html5QrcodeResult } from 'html5-qrcode';
import CenterOnParent from '../../util/CenterOnParent';
import { handleError, initClient } from '../../../api';
import { PresenceViaQrRequest, VisitorManagementUiClient } from '../../backend/backendapi';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: { CenterOnParent },
})
export default class CheckInOutScanner extends Vue {
  html5QrCode: Html5Qrcode | null = null;
  scanning = false;
  stopTask: NodeJS.Timeout | string | number | undefined = undefined;
  private readonly api = initClient(VisitorManagementUiClient);

  get readerElementId(): string {
    return this.uid + '_reader';
  }

  get uid(): string {
    return this._uid;
  }

  mounted(): void {
    this.html5QrCode = new Html5Qrcode(this.readerElementId);
  }

  beforeDestroy(): void {
    this.stopScanner();
  }

  async onScanSuccess(decodedText: string, result: Html5QrcodeResult): Promise<void> {
    await this.stopScanner();

    try {
      const res = await this.api.presenceViaQr(PresenceViaQrRequest.fromJS({ qrCode: decodedText }));
      if (res.presence.endAt === undefined) {
        this.$toasted.info(this.$t('visitorManagement.checkedIn').toString());
      } else {
        this.$toasted.info(this.$t('visitorManagement.checkedOut').toString());
      }
      //TOOD do something the result?
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    }
  }

  onScanFailure(error) {
    // Quietly handle frame misses
  }

  async startScanner(): Promise<void> {
    try {
      if (!this.html5QrCode) {
        return;
      }
      await this.html5QrCode.start(
          { facingMode: 'environment' },
          {
            fps: 30, // Sample the video frames at the maximum software speed

            // REMOVED qrbox: 
            // Scanning the full frame gives moving items maximum real-estate to be caught.

            videoConstraints: {
              facingMode: 'environment',
              // Request maximum fluid frame rate to eliminate motion blur
              frameRate: { ideal: 60, min: 30 },

              // 720p resolution is the ultimate sweet spot for rapid canvas matrix reading
              width: { ideal: 1280 },
              height: { ideal: 720 },

              // Advanced mobile options to lock properties and minimize shutter adjust delay
              focusMode: 'continuous',
              whiteBalanceMode: 'continuous',
              exposureMode: 'continuous',
            },
          },
          this.onScanSuccess.bind(this),
          this.onScanFailure.bind(this));
      this.stopTask = setTimeout(() => this.stopScanner, 30 * 1000);
      this.scanning = true;
    } catch (err) {
      console.error('Unable to start scanning.', err);
      alert('Camera access denied or unavailable.');
    }
  }

  async stopScanner(): Promise<void> {
    if (!this.html5QrCode) {
      return;
    }
    try {
      await this.html5QrCode.stop();
      clearTimeout(this.stopTask);
      this.scanning = false;
    } catch (err) {
      console.error('Failed to stop scanning.', err);
    }
  }
}
